import {ReferenceType} from "./ReferenceType";

export interface Agreement {
    id: string;
    signedDate: string;
    referenceId: string;
    businessId: string;
    referenceType: ReferenceType;
    signatureState: SignatureState;
    content: string;
    pdfUrl: string;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
}

export enum SignatureState {
    Unsigned = "Unsigned",
    Signed = "Signed"
}